interface BrandMarkProps {
  /** Rendered width/height in px. */
  size?: number;
  /** Class applied to the <svg> (e.g. `brand-mark` or `auth-mark`). */
  className?: string;
}

/**
 * Fifty 410 brand mark — an orange rounded-square tile with a white envelope.
 * Shared by the sidebar, the topbar, and the sign-in screen so the mark stays
 * pixel-identical everywhere.
 */
function BrandMark({ size = 27, className }: BrandMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <rect width="100" height="100" rx="22" fill="#E2551F" />
      <path d="M26 34 L74 34 L74 66 L26 66 Z" fill="none" stroke="#fff" strokeWidth="5" strokeLinejoin="round" />
      <path d="M26 34 L50 52 L74 34" fill="none" stroke="#fff" strokeWidth="5" strokeLinejoin="round" />
    </svg>
  );
}

export default BrandMark;
